import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Inject meta tags immediately (before React hydration) so link scrapers pick them up
const injectMeta = (attr: string, value: string, content: string) => {
  let el = document.querySelector(`meta[${attr}="${value}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
document.title = 'Escape 9-a-5 | El Método para Mujeres Latinas — Solo $6.36';
injectMeta('property', 'og:title', 'Escape 9-a-5 — El Método que Está Revolucionando Estados Unidos');
injectMeta('property', 'og:description', 'El método exclusivo para mujeres latinas que quieren libertad financiera desde casa. Sin jefes. Sin horarios. Solo $6.36.');
injectMeta('property', 'og:type', 'website');
injectMeta('property', 'og:site_name', 'Escape 9-a-5');
injectMeta('name', 'description', 'El método exclusivo para mujeres latinas que quieren libertad financiera desde casa. Sin jefes. Sin horarios. Solo $6.36.');
injectMeta('name', 'twitter:card', 'summary_large_image');
injectMeta('name', 'twitter:title', 'Escape 9-a-5 — El Método para Mujeres Latinas');
injectMeta('name', 'twitter:description', 'Libertad financiera desde casa. Sin jefes. Sin horarios. Solo $6.36.');
render(<App data-id="element-346" />, document.getElementById('root'));